<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Provisionamento / Aguardando ativação</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="$router.go(-1)" class="btn btn-outline-primary">
            <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width class="me-1"/>Voltar
          </button>
        </div>

        <div class="mb-3">
          <button v-on:click="atualizarHandle()" class="btn btn-primary">
            Atualizar
          </button>
        </div>
      </div>

      <div class="d-flex">
        <!-- mobile -->
        <table v-if="isMobile()" class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th>ONU</th>
              <th class="text-center">Sinal</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="onu in listaOnus" :key="onu.id" v-on:click="modalOnuAbre(onu)" :class="cssRowOnu(onu)" class="cursor-pointer">
              <td scope="row">
                {{getOlt(onu.olt_id).descricao}} <strong>[1/{{onu.slot}}/{{onu.porta_pon}}:<span v-if="(onu.estagio === 'oePreAtivacao')">{{onu.pre_index}}</span>]</strong>
                <br><strong>[{{onu.serial_number}}]</strong> {{onu.descricao}}
                <font-awesome-icon v-if="(onu.estagio === 'oePreAtivacao')" :icon="['fas', 'level-up-alt']" fixed-width class="blinking"/>
              </td>
              <td class="text-center">
                {{traduzEstagio(onu.estagio)}}
                <p v-if="(onu.estagio !== 'oePreAtivacao')" class="mb-0">-</p>
                <p v-if="(onu.estagio === 'oePreAtivacao')" class="mb-0">{{formataSinalFibra(onu.sinal)}}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- mobile -->

        <!-- desktop -->
        <table v-if="!isMobile()" class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="140">OLT</th>
              <th class="text-center" width="70">Porta</th>
              <th width="140">Número de série</th>
              <th>Descrição</th>
              <th width="100">Status</th>
              <th class="text-center" width="60">Sinal</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="onu in listaOnus" :key="onu.id" v-on:click="modalOnuAbre(onu)" :class="cssRowOnu(onu)">
              <td scope="row" class="cursor-pointer">{{descricaoOlt(onu.olt_id)}}</td>
              <td class="text-center cursor-pointer">
                1/{{onu.slot}}/{{onu.porta_pon}}
                <span v-if="(onu.estagio === 'oePreAtivacao')">[{{onu.pre_index}}]</span>
              </td>
              <td class="cursor-pointer">
                {{onu.serial_number}}
                <font-awesome-icon v-if="(onu.estagio === 'oePreAtivacao')" :icon="['fas', 'level-up-alt']" fixed-width class="blinking"/>
              </td>
              <td class="cursor-pointer">
                {{onu.descricao}}
              </td>
              <td class="cursor-pointer">{{traduzEstagio(onu.estagio)}}</td>
              <td v-if="(onu.estagio !== 'oePreAtivacao')" class="text-center cursor-pointer"> - </td>
              <td v-if="(onu.estagio === 'oePreAtivacao')" class="text-center cursor-pointer">
                {{formataSinalFibra(onu.sinal) || '-'}}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- desktop -->
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
      <div class="form-group">
        <font-awesome-icon v-if="(atualizandoSinal)" :icon="['fas', 'spinner']" fixed-width spin class="text-muted-2 ms-1"/>
      </div>
    </div>

    <!-- modal-onu-descoberta -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-onu-descoberta" id="btn-modal-onu-descoberta-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-onu-descoberta" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div v-if="(modalOnuDescoberta.onu)" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'level-up-alt']" fixed-width/>
              Registrar ONU
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p class="mb-0"><span class="fw-bold">OLT:</span> {{getOlt(modalOnuDescoberta.onu.olt_id).descricao}}</p>
                <p class="mb-0"><span class="fw-bold">
                  PON:</span> 1/{{modalOnuDescoberta.onu.slot}}/{{modalOnuDescoberta.onu.porta_pon}}
                  <span v-if="(modalOnuDescoberta.onu.estagio === 'oePreAtivacao')">[{{modalOnuDescoberta.onu.pre_index}}]</span>
                </p>
                <p class="mb-0"><span class="fw-bold">Serial number:</span> {{modalOnuDescoberta.onu.serial_number}}</p>
              </div>

              <div class="col-12">
                <hr class="my-1">
              </div>

              <div class="col-12 col-sm-6 mb-2">
                <label class="required----">Instalador</label>
                <select v-model="modalOnuDescoberta.form.instalador" class="form-select" disabled>
                  <option disabled :value="undefined">Selecione</option>
                </select>
              </div>
              <div class="mb-2 col-12 col-sm-6">
                <label class="required">Identificação</label>
                <input type="text" v-model="modalOnuDescoberta.form.descricao" class="form-control">
              </div>

              <div class="mb-2 col-12 col-sm-4">
                <label class="required w-100">
                  Perfil
                  <label v-bind:class="cssCheckboxModeloAuto(modalOnuDescoberta.onu)" class="custom-control custom-checkbox float-end">
                    <input type="checkbox" v-bind:disabled="!podeEscolherAuto(modalOnuDescoberta.onu)" v-model="modalOnuDescoberta.form.modeloAuto" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description ms-1">Automático</span>
                    <Tooltip v-if="!modalOnuDescoberta.onu.modelo_auto_id" position="left" :tooltipText="'Contate o suporte para homologação'" class="d-inline d-sm-none">
                      <span class="text-warning cursor-pointer ms-1">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" fixed-width/>
                      </span>
                    </Tooltip>
                    <Tooltip v-if="!modalOnuDescoberta.onu.modelo_auto_id" position="right" :tooltipText="'Contate o suporte para homologação'" class="d-none d-sm-inline">
                      <span class="text-warning cursor-pointer ms-1">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" fixed-width/>
                      </span>
                    </Tooltip>
                  </label>
                </label>
                <select v-model="modalOnuDescoberta.form.tipoOnu"
                    v-bind:disabled="!podeEscolherModelo(modalOnuDescoberta.onu)"
                    class="form-select">
                  <option disabled :value="undefined">Selecione</option>
                  <option v-for="perfil in modalOnuDescoberta.tiposOnu" :key="perfil.id" :value="perfil.id">
                    {{perfil.nome_olt}}
                  </option>
                </select>
              </div>
              <div class="mb-2 col-12 col-sm-4">
                <label class="required">Modo operação</label>
                <select v-model="modalOnuDescoberta.form.modo"
                    class="form-select">
                  <option disabled :value="'mdNaoDefinido'">Selecione</option>
                  <option :value="'mdBridge'">Onu bridge</option>
                  <option :value="'mdRouter'">Onu roteada</option>
                </select>
              </div>
              <div class="mb-2 col-12 col-sm-4">
                <label class="required">VLAN</label>
                <select v-model="modalOnuDescoberta.form.vlan"
                    class="form-select">
                  <option disabled :value="undefined">Selecione</option>
                  <option v-for="vlan in modalOnuDescoberta.listaVlans" :key="vlan.vlan" :value="vlan.vlan">
                    {{vlan.vlan}} - {{vlan.descricao}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-onu-descoberta-fecha">Fechar</button>
            <button type="button"
                v-if="(modalOnuDescoberta.onu.estagio === 'oeDiscovery')"
                v-on:click="modalOnuDescobertaSubirOnuHandle()"
                v-bind:disabled="!modalOnuDescobertaPodeSubirOnu()"
                class="btn btn-success">
              Validar nível de sinal
              <font-awesome-icon :icon="['fas', 'forward']" fixed-width/>
            </button>
            <button type="button"
                v-if="(modalOnuDescoberta.onu.estagio === 'oePreAtivacao')"
                v-on:click="modalOnuDescobertaSubirOnuHandle()"
                v-bind:disabled="!modalOnuDescobertaPodeSubirOnu()"
                class="btn btn-success">
              Salvar
              <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-onu-descoberta -->

    <!-- modal-aprova-onu -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-aprova-onu" id="btn-modal-aprova-onu-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-aprova-onu" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div v-if="(modalAprovaOnu.onu)" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
              Confirmar ONU
            </h5>
            <button type="button" v-on:click="modalAprovaOnu.onu = undefined;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p class="mb-0"><span class="fw-bold">OLT:</span> {{getOlt(modalAprovaOnu.onu.olt_id).descricao}}</p>
                <p class="mb-0"><span class="fw-bold">PON:</span> 1/{{modalAprovaOnu.onu.slot}}/{{modalAprovaOnu.onu.porta_pon}}</p>
                <p class="mb-0"><span class="fw-bold">Índice ONU:</span> {{modalAprovaOnu.onu.pre_index}}</p>
                <p class="mb-0"><span class="fw-bold">Serial number:</span> {{modalAprovaOnu.onu.serial_number}}</p>
                <p class="mb-0"><span class="fw-bold">Descrição:</span> {{modalAprovaOnu.onu.descricao}}</p>
              </div>

              <div class="col-12 mb-2">
                <hr class="my-1">
              </div>

              <div class="col-12 text-center">
                <p class="mb-0 fs-2 text-muted-2">Sinal</p>
                <p class="mb-0 fs-3" :class="cssSinalOnu(modalAprovaOnu.onu)">{{formataSinalFibra(modalAprovaOnu.onu.sinal) || '-'}}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <font-awesome-icon v-if="(modalAprovaOnu.atualizandoSinal)" :icon="['fas', 'spinner']" fixed-width spin class="text-muted-2 ms-1"/>
            <button type="button" class="btn btn-outline-secondary d-none" data-bs-dismiss="modal" id="btn-modal-aprova-onu-fecha">Fechar</button>
            <button type="button" v-on:click="modalAprovaOnuVoltarParaEditarHandle()" class="btn btn-outline-primary">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editar
            </button>
            <button type="button" v-on:click="modalOnuDescobertaDesativarOnuHandle(modalAprovaOnu.onu)" class="btn btn-outline-danger">
              Desautorizar ONU
              <font-awesome-icon :icon="['fas', 'undo']" fixed-width/>
            </button>
            <button type="button" v-on:click="modalOnuDescobertaAtivarOnuHandle(modalAprovaOnu.onu)" v-bind:disabled="!podeAprovar(modalAprovaOnu.onu)" class="btn btn-success">
              Aprovar ONU
              <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-aprova-onu -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: 'ProvisionamentoOnus',

  components: {
    Paginador,
    Tooltip,
  },

  data() {
    return {
      atualizandoSinal: undefined,
      listaOlts: [],
      listaOnus: [],
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      intervaloAtualizaSinal: undefined,
      modalOnuDescoberta: {
        onu: undefined,
        listaVlans: [],
        tiposOnu: [],
        form: {
          descricao: '',
          modeloAuto: true,
          tipoOnu: undefined,
          modo: 'mdNaoDefinido',
          vlan: undefined,
        },
      },
      modalAprovaOnu: {
        onu: undefined,
        atualizandoSinal: false,
      },
    }
  },

  methods: {
    // TODO: REFATORAR
    isMobile() {
      return (window.innerWidth < 800);
    },

    carregaOlts() {
      const apiUrl =
          `/servidores/olt?paginacao.porPagina=-1`;

      api.get(apiUrl).then(res => {
        this.listaOlts = res.data.itens;
      }).catch(() => {
        setTimeout(this.carregaOlts, 2000);
      });
    },

    carregaOnus() {
      const apiUrl =
          `/isp/onu/discovery?${this.paginador.requestParams}&estagio[neq]=oeAtivado`;

      loading(true);

      api.get(apiUrl).then(res => {
        loading(false);

        this.listaOnus = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    atualizarHandle() {
      this.carregaOnus();
    },

    onChangePaginacao() {
      this.carregaOnus();
    },

    getOlt(id) {
      if (!id) {
        return undefined;
      }

      const olt = this.listaOlts.find(x => (x.id === id));

      return olt;
    },

    descricaoOlt(id) {
      const olt = this.getOlt(id);
      if (!olt) {
        return '-';
      }

      return olt.descricao;
    },

    atualizaSinal() {
      const _vm = this;

      const ids = this.listaOnus.map(x => {
        return x.id.toString();
      });

      if (!ids || !ids.length) {
        return;
      }

      const apiUrl =
          `/isp/onu/discovery?id[in]=${ids}`;

      this.atualizandoSinal = true;
      api.get(apiUrl).then(res => {
        _vm.listaOnus.forEach(y => {
          res.data.itens.forEach(x => {
            if (x.id === y.id) {
              y.sinal = x.sinal;
            }
          });
        });

        this.atualizandoSinal = false;
      }).catch(() => {
        this.atualizandoSinal = false;
      });
    },

    cssCheckboxModeloAuto(onu) {
      if (this.podeEscolherAuto(onu)) {
        return ['cursor-pointer'];
      }

      return ['text-muted-2'];
    },

    podeEscolherAuto(onu) {
      switch (true) {
        case onu.estagio !== 'oeDiscovery':
        case !onu.modelo_auto_id:
          return false;
      }

      return true;
    },

    podeEscolherModelo(onu) {
      switch (true) {
        case onu.estagio !== 'oeDiscovery':
        case this.modalOnuDescoberta.form.modeloAuto:
          return false;
      }

      return true;
    },

    podeAprovar(onu) {
      const tipoOnuDefinido = (onu.tipo_onu || onu.modelo_auto)
      if (!onu.info_onu_pre || !onu.vlan || !onu.descricao || !tipoOnuDefinido) {
        return false;
      }

      return true;
    },

    traduzEstagio(estagio) {
      switch (estagio) {
        case 'oeDiscovery':
          return 'Nova ONU';

        case 'oePreAtivacao':
          return 'Pré-ativado';

        case 'oeAtivado':
          return 'Já ativado';

        default:
          return '(Desconhecido)';
      }
    },

    cssRowOnu(onu) {
      switch (true) {
        case (onu.estagio === 'oePreAtivacao'):
          return this.cssSinalOnu(onu);

        default:
          return 'text-muted';
      }
    },

    cssSinalOnu(onu) {
      const sinalCriticoAlto = -1600;
      const sinalAlertaAlto = -1700;
      const sinalAlertaBaixo = -2800;
      const sinalCriticoBaixo = -3000;

      switch (true) {
        case (onu.sinal < sinalCriticoBaixo || onu.sinal > sinalCriticoAlto):
          return 'text-danger';

        case (onu.sinal < sinalAlertaBaixo || onu.sinal > sinalAlertaAlto):
          return 'text-warning';

        default:
          return 'text-info';
      }
    },

    modalOnuAbre(onu) {
      switch (onu.estagio) {
        case 'oeDiscovery':
          this.modalOnuDescobertaAbreHandle(onu);
          break;

        case 'oePreAtivacao':
          this.modalAprovaOnuAbre(onu);
          break;

        default:
          dialogo.alerta('O estágio da ONU é inválido. Entre em contato com o suporte.');
      }
    },

    /////////////////////////////////////
    // modal-onu-descoberta
    modalOnuDescobertaAbreHandle(onu) {
      this.modalOnuDescobertaReset();

      this.modalOnuDescoberta.onu = clone(onu);

      this.modalOnuDescoberta.form.descricao = onu.descricao;
      this.modalOnuDescoberta.form.tipoOnu = onu.tipo_onu;
      this.modalOnuDescoberta.form.vlan = onu.vlan;
      this.modalOnuDescoberta.form.modeloAuto = onu.modelo_auto;
      this.modalOnuDescoberta.form.modo = onu.modo;

      this.modalOnuDescobertaAbre();
      this.modalOnuDescobertaCarregaVlans();
      this.modalOnuDescobertaCarregaTiposOnu();
    },

    modalOnuDescobertaAbre() {
      document.getElementById('btn-modal-onu-descoberta-abre').click();
    },

    modalOnuDescobertaFecha() {
      document.getElementById('btn-modal-onu-descoberta-fecha').click();
    },

    modalOnuDescobertaReset() {
      this.modalOnuDescoberta.onu = undefined;
      this.modalOnuDescoberta.form.descricao = '';
      this.modalOnuDescoberta.form.modeloAuto = false;
      this.modalOnuDescoberta.form.tipoOnu = undefined;
      this.modalOnuDescoberta.form.modo = 'mdNaoDefinido';
      this.modalOnuDescoberta.form.vlan = undefined;
    },

    modalOnuDescobertaCarregaVlans() {
      const oltID = this.modalOnuDescoberta.onu.olt_id;
      const apiUrl = `/servidores/olt/${oltID}/vlans?visivel=1&orderBy[vlan]=asc&paginacao.porPagina=-1`;

      loading(true);
      api.get(apiUrl).then(res => {
        loading(false);

        this.modalOnuDescoberta.listaVlans = res.data.itens;
        if (this.modalOnuDescoberta.listaVlans.length === 1) {
          this.modalOnuDescoberta.form.vlan = this.modalOnuDescoberta.listaVlans[0].vlan;
        }
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    modalOnuDescobertaCarregaTiposOnu() {
      const oltID = this.modalOnuDescoberta.onu.olt_id;

      const apiUrl =
          `/servidores/olt/${oltID}/tipos-onu?is_sgm_auto=0&paginacao.porPagina=-1`;

      loading(true);

      api.get(apiUrl).then(res => {
        loading(false);

        this.modalOnuDescoberta.tiposOnu = res.data.itens;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    modalOnuDescobertaPodeSubirOnu() {
      const form = this.modalOnuDescoberta.form;

      switch (true) {
        case (!form.descricao):
        case (!form.modeloAuto && !form.tipoOnu):
        case (!form.modo || form.modo === 'mdNaoDefinido'):
        case (!form.vlan):
          return false;

        default:
          return true;
      }
    },

    modalOnuDescobertaSubirOnuHandle() {
      const id = this.modalOnuDescoberta.onu.id;
      const form = this.modalOnuDescoberta.form;

      const sendData = {
        descricao: form.descricao,
        modelo_auto: form.modeloAuto,
        tipo_onu: form.tipoOnu,
        modo: form.modo,
        vlan: form.vlan,
      };

      const apiUrl =
          `/isp/onu/discovery/${id}`;

      loading(true);

      api.post(apiUrl, sendData).then(res => {
        loading(false);
        this.carregaOnus();
        this.modalOnuDescobertaFecha();
        this.modalAprovaOnuAbre(res.data);
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    modalOnuDescobertaDesativarOnuHandle(onu) {
      dialogo.confirmacao(`Confirma cancelar a ativação da ONU <b>[${onu.serial_number}] ${onu.descricao}</b>?`).then(() => {
        const apiUrl =
            `/isp/onu/discovery/${onu.id}`;

        const sendData = {
          estagio: 'oeDiscovery',
        };

        loading(true);

        api.patch(apiUrl, sendData).then(() => {
          loading(false);

          this.carregaOnus();
          this.modalAprovaOnuFecha();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    modalOnuDescobertaAtivarOnuHandle(onu) {
      dialogo.confirmacao(`Confirma efetuar a ativação da ONU <b>[${onu.serial_number}] ${onu.descricao}</b>?`).then(() => {
        const apiUrl = `/isp/onu/discovery/${onu.id}`;

        const sendData = {
          estagio: 'oeAtivado',
        };

        loading(true);

        api.patch(apiUrl, sendData).then(() => {
          loading(false);
          this.carregaOnus();
          this.modalAprovaOnuFecha();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },
    // modal-onu-descoberta
    /////////////////////////////////////




    /////////////////////////////////////
    // modal-aprova-onu
    modalAprovaOnuAbre(onu) {
      this.modalAprovaOnu.onu = clone(onu);
      document.getElementById('btn-modal-aprova-onu-abre').click();
    },

    modalAprovaOnuFecha() {
      this.modalAprovaOnu.onu = undefined;
      document.getElementById('btn-modal-aprova-onu-fecha').click();
    },

    modalAprovaOnuAtualizaSinal() {
      if (!this.modalAprovaOnu.onu || !this.modalAprovaOnu.onu.id) {
        return;
      }

      const _vm = this;
      const ids = [this.modalAprovaOnu.onu.id.toString()];
      const apiUrl = `/isp/onu/discovery?id[in]=${ids}`;

      this.modalAprovaOnu.atualizandoSinal = true;

      api.get(apiUrl).then(res => {
        this.modalAprovaOnu.onu.sinal = res.data.itens[0].sinal;
        _vm.modalAprovaOnu.atualizandoSinal = false;
      }).catch(() => {
        _vm.modalAprovaOnu.atualizandoSinal = false;
      });
    },

    modalAprovaOnuVoltarParaEditarHandle() {
      this.modalOnuDescobertaAbreHandle(this.modalAprovaOnu.onu);
      this.modalAprovaOnuFecha();
    },
    // modal-aprova-onu
    /////////////////////////////////////




    // TODO: REFATORAR ESTA FUNÇÃO
    formataSinalFibra(sinal) {
      if ((!sinal && sinal !== 0) || sinal === -7000) {
        return '';
      }

      const s = sinal.toString();

      switch (true) {
        case sinal === 0:
          return '0.00';

        case sinal > 0 && sinal <= 9:
          return `0.0${s[0]}`;

        case sinal > 0 && sinal <= 99:
          return `0.${s[0]}${s[1]}`;

        case sinal > 0 && sinal <= 999:
          return `${s[0]}.${s[1]}${s[2]}`;

        case sinal > 0:
          return `${s[0]}${s[1]}.${s[2]}${s[3]}`;

        case sinal < 0 && sinal >= -9:
          return `-0.0${s[1]}`;

        case sinal < 0 && sinal >= -99:
          return `-0.${s[1]}${s[2]}`;

        case sinal < 0 && sinal >= -999:
          return `-${s[1]}.${s[2]}${s[3]}`;

        default:
          return `-${s[1]}${s[2]}.${s[3]}${s[4]}`;
      }
    }
  },

  created() {
    this.carregaOlts();
    this.carregaOnus();
    this.intervaloAtualizaSinal = setInterval(this.atualizaSinal, 5000);
    this.intervaloAtualizaSinalConfirmacao = setInterval(this.modalAprovaOnuAtualizaSinal, 3000);
  },
  destroyed() {
    clearInterval(this.intervaloAtualizaSinal);
    clearInterval(this.intervaloAtualizaSinalConfirmacao);
  },
}
</script>

<style>
.blinking {
      animation: blinking 1s linear infinite;
      -moz-animation: blinking 1s linear infinite;
      -webkit-animation: blinking 1s linear infinite;
      -o-animation: blinking 1s linear infinite;
    }
    @keyframes blinking {
  50% {
    opacity: 0;
  }
  0%,
  100% {
    opacity: 1;
  }
}

  </style>